//src/admin/ExamPage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Autocomplete,
  Checkbox,
  TextField
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
//const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
//const checkedIcon = <CheckBoxIcon fontSize="small" />;
const EXAMS_API = `${BASE_URL}/api/exams`;
const CHECK_EXAM_NAME_API = `${BASE_URL}/api/exams/check-exam-name`;
const SUBJECTS_API = `${BASE_URL}/api/subjects/filtersubjects`;
const COURSES_API = `${BASE_URL}/api/course`;
const CLASSES_API = `${BASE_URL}/api/classes`;
const ACADEMICYEARS_API = `${BASE_URL}/api/academic-yearsss`; // new
const ExamPage = () => {
// Current date - local date
  const getTodayLocal = () => {
    const d = new Date();

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const today = getTodayLocal();
  const [formData, setFormData] = useState({
    ExamName: "",
    SubjectIDs: [],
    CourseID: "",
     ////SectionID: "",
    //ClassID: "",
     // Multiple selection
    //ClassIDs: [],
    //SectionIDs: [],


    Classes:[
        {
            ClassID:"",
            SectionIDs:[]
        }
    ],

    AcademicYearID: "",
     // One schedule for each subject
    SubjectSchedules: {},
    MinMarks: "",
    TotalMarks: "",
    CreatedBy: "admin",
    //CreatedDate: new Date().toISOString().split("T")[0],
    CreatedDate: today,
    UpdatedBy: null,
    UpdatedDate: null,
  });
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
 const [academicYears, setAcademicYears] = useState([]);
 //const [sections, setSections] = useState([]);
 //const [hasSections, setHasSections] =useState(false);

 const [sectionMap,setSectionMap]=useState({});


  useEffect(() => {
    axios.get(COURSES_API).then((res) => setCourses(res.data));
  }, []);
// load academic years for selected course
  useEffect(() => {
    if (formData.CourseID) {
      axios.get(`${ACADEMICYEARS_API}?course=${formData.CourseID}`)
        .then((res) => setAcademicYears(res.data));
    } else {
      setAcademicYears([]);
    }
  }, [formData.CourseID]);
  //load classes for selected course
 /*  useEffect(() => {
    if (formData.CourseID) {
      axios.get(`${CLASSES_API}?course=${formData.CourseID}`).then((res) => {
        const classData = res.data.map((c) => ({
          ClassID: c.ClassID || c.id,
          name: c.name,
        }));
        setClasses(classData);
      });
    }
  }, [formData.CourseID]); */

useEffect(() => {

    if(!formData.CourseID){

        setClasses([]);
        return;

    }

    axios
    .get(`${CLASSES_API}?course=${formData.CourseID}`)
    .then(res=>{

        setClasses(

            res.data.map(c=>({

                ClassID:c.ClassID || c.id,
                name:c.name

            }))

        );

    });

},[formData.CourseID]);
//load subjects


useEffect(() => {

    if (!formData.CourseID) {
        setSubjects([]);
        return;
    }

    const firstClass = formData.Classes.find(
        c => c.ClassID !== ""
    );

    if (!firstClass) {
        setSubjects([]);
        return;
    }

    axios
        .get(
            `${SUBJECTS_API}?courseID=${formData.CourseID}&classID=${firstClass.ClassID}`
        )
        .then(res => {
            setSubjects(res.data);
        });

}, [formData.CourseID, formData.Classes]);


/* useEffect(()=>{

    if(

        !formData.CourseID ||

        formData.ClassIDs.length===0

    ){

        setSubjects([]);
        return;

    }

    axios

    .get(

        `${SUBJECTS_API}?courseID=${formData.CourseID}&classID=${formData.ClassIDs[0]}`

    )

    .then(res=>{

        setSubjects(res.data);

    });

},[formData.CourseID,formData.ClassIDs]); */

 /*  useEffect(() => {
    if (formData.CourseID && formData.ClassID) {
      axios
        .get(`${SUBJECTS_API}?courseID=${formData.CourseID}&classID=${formData.ClassID}`)
        .then((res) => setSubjects(res.data));
    }
  }, [formData.CourseID, formData.ClassID]); */
  //Load Section for Class
  /* useEffect(() => {
    if (!formData.ClassID) {
        setSections([]);
        setHasSections(false);
        setFormData(prev => ({
            ...prev,
            SectionID: null
        }));
        return;
    }
    axios
        .get(`${BASE_URL}/api/sections/${formData.ClassID}`)
        .then(res => {

            if (res.data.length > 0) {
                setSections(res.data);
                setHasSections(true);

                setFormData(prev => ({
                    ...prev,
                    SectionID: ""
                }));
            } else {

                // No sections

                setSections([]);
                setHasSections(false);

                setFormData(prev => ({
                    ...prev,
                    SectionID: null
                }));
            }

        });

}, [formData.ClassID]); */

/* useEffect(() => {

    if(formData.ClassIDs.length===0){

        setSections([]);
        setHasSections(false);

        setFormData(prev=>({

            ...prev,
            SectionIDs:[]

        }));

        return;

    }

    Promise.all(

        formData.ClassIDs.map(classId=>

            axios.get(`${BASE_URL}/api/sections/${classId}`)

        )

    )

    .then(results=>{

        let allSections=[];

        results.forEach(r=>{

            allSections=[

                ...allSections,
                ...r.data

            ];

        });

        // remove duplicates

        const uniqueSections=[];

        const ids=[];

        allSections.forEach(sec=>{

            if(!ids.includes(sec.SectionID)){

                ids.push(sec.SectionID);

                uniqueSections.push(sec);

            }

        });

        setSections(uniqueSections);

        setHasSections(uniqueSections.length>0);

    })

    .catch(()=>{

        setSections([]);
        setHasSections(false);

    });

},[formData.ClassIDs]); */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
//Multiple Class Selection Handler
/* const handleClassSelection=(e)=>{

const values=[...e.target.selectedOptions].map(

option=>Number(option.value)

);

setFormData(prev=>({

...prev,

ClassIDs:values,

SectionIDs:[]

}));

};
//Multiple Section Selection Handler
const handleSectionSelection=(e)=>{

const values=[...e.target.selectedOptions].map(

option=>Number(option.value)

);

setFormData(prev=>({

...prev,

SectionIDs:values

}));

}; */

 /*  const handleSubjectCheckbox = (subjectId) => {
    setFormData((prev) => {
      const alreadySelected = prev.SubjectIDs.includes(subjectId);
      return {
        ...prev,
        SubjectIDs: alreadySelected
          ? prev.SubjectIDs.filter((id) => id !== subjectId)
          : [...prev.SubjectIDs, subjectId],
      };
    });
  }; */
const handleSubjectCheckbox = (subjectId) => {

    setFormData((prev) => {

        const alreadySelected =
            prev.SubjectIDs.includes(subjectId);

        if (alreadySelected) {

            const updatedSchedules = {
                ...prev.SubjectSchedules
            };

            delete updatedSchedules[subjectId];

            return {
                ...prev,

                SubjectIDs: prev.SubjectIDs.filter(
                    id => id !== subjectId
                ),

                SubjectSchedules: updatedSchedules
            };
        }

        return {
            ...prev,

            SubjectIDs: [
                ...prev.SubjectIDs,
                subjectId
            ],

            SubjectSchedules: {
                ...prev.SubjectSchedules,

                [subjectId]: {
                    ExamDate: "",
                    StartTime: "",
                    EndTime: ""
                }
            }
        };
    });
};

const handleSubjectScheduleChange = (
    subjectId,
    field,
    value
) => {

    setFormData(prev => ({
        ...prev,

        SubjectSchedules: {
            ...prev.SubjectSchedules,

            [subjectId]: {
                ...(prev.SubjectSchedules[subjectId] || {}),
                [field]: value
            }
        }
    }));
};

/* const validateForm = () => {

    if (formData.ExamName.trim() === "") {

        alert("Please enter Exam Name.");
        return false;

    }

    if (!formData.CourseID) {

        alert("Please select Course.");
        return false;

    }

    if (!formData.AcademicYearID) {

        alert("Please select Academic Year.");
        return false;

    }

        if (
    formData.Classes.filter(c => c.ClassID !== "").length === 0
) {
    alert("Please select at least one Class");
    return false;
}

        for (const cls of formData.Classes) {

    if (!cls.ClassID)
        continue;

    const available =
        sectionMap[cls.ClassID] || [];

    if (
        available.length > 0 &&
        cls.SectionIDs.length === 0
    ) {
        alert("Please select sections.");
        return false;
    }
}

 if (!formData.ExamDate) {

            alert("Please select Exam Date.");
            return false;

        }

        if (!formData.StartTime) {

            alert("Please enter Start Time.");
            return false;

        }

        if (!formData.EndTime) {

            alert("Please enter End Time.");
            return false;

        }

        if (formData.EndTime <= formData.StartTime) {

            alert(
                "End Time must be greater than Start Time."
            );

            return false;

        }


    if (formData.SubjectIDs.length === 0) {

        alert("Please select at least one Subject.");
        return false;

    }

    if (!formData.MinMarks) {

        alert("Please enter Minimum Marks.");
        return false;

    }

    if (!formData.TotalMarks) {

        alert("Please enter Total Marks.");
        return false;

    }

    if (

        Number(formData.MinMarks) >

        Number(formData.TotalMarks)

    ) {

        alert("Minimum Marks cannot be greater than Total Marks.");

        return false;

    }

    return true;

}; */

const validateForm = () => {

    if (formData.ExamName.trim() === "") {
        alert("Please enter Exam Name.");
        return false;
    }

    if (!formData.CourseID) {
        alert("Please select Course.");
        return false;
    }

    if (!formData.AcademicYearID) {
        alert("Please select Academic Year.");
        return false;
    }

    if (
        formData.Classes.filter(
            c => c.ClassID !== ""
        ).length === 0
    ) {
        alert("Please select at least one Class.");
        return false;
    }

    // Validate sections
    for (const cls of formData.Classes) {

        if (!cls.ClassID) continue;

        const available =
            sectionMap[cls.ClassID] || [];

        if (
            available.length > 0 &&
            cls.SectionIDs.length === 0
        ) {
            alert(
                `Please select sections for Class.`
            );
            return false;
        }
    }

    if (formData.SubjectIDs.length === 0) {
        alert("Please select at least one Subject.");
        return false;
    }

    // -----------------------------------------
    // Validate schedule for EVERY subject
    // -----------------------------------------

    /* const today =
        new Date().toISOString().split("T")[0]; */

    for (const subjectId of formData.SubjectIDs) {

        const schedule =
            formData.SubjectSchedules[subjectId];

        const subject =
            subjects.find(
                s => Number(s.SubjectID) === Number(subjectId)
            );

        const subjectName =
            subject?.SubjectName || "Selected Subject";

        /* if (!schedule?.ExamDate) {

            alert(
                `Please select Exam Date for ${subjectName}.`
            );

            return false;
        } */

        // Date cannot be before today
        /* if (schedule.ExamDate < today) {

            alert(
                `Exam Date for ${subjectName} cannot be before today's date.`
            );

            return false;
        } */

       /*  if (!schedule?.StartTime) {

            alert(
                `Please enter Start Time for ${subjectName}.`
            );

            return false;
        } */

       /*  if (!schedule?.EndTime) {

            alert(
                `Please enter End Time for ${subjectName}.`
            );

            return false;
        } */

       /*  if (
            schedule.EndTime <=
            schedule.StartTime
        ) {

            alert(
                `End Time must be greater than Start Time for ${subjectName}.`
            );

            return false;
        } */
    }

    if (!formData.MinMarks) {
        alert("Please enter Minimum Marks.");
        return false;
    }

    if (!formData.TotalMarks) {
        alert("Please enter Total Marks.");
        return false;
    }

    if (
        Number(formData.MinMarks) >
        Number(formData.TotalMarks)
    ) {
        alert(
            "Minimum Marks cannot be greater than Total Marks."
        );

        return false;
    }

    return true;
};


 /*  const handleSubmit = (e) => {
    e.preventDefault();
    // Step 1: Check if exam name exists
    axios
      .post(CHECK_EXAM_NAME_API, { 
        ExamName: formData.ExamName,
        AcademicYearID: formData.AcademicYearID,
        CourseID: formData.CourseID,
        ClassID: formData.ClassID,
        //SectionID: formData.SectionID,
         SectionID: hasSections ? formData.SectionID : null
      })
      .then((res) => {
        if (res.data.exists) {
          alert("Exam name already exists. Please choose a different name.");
        } else {
          // Step 2: Proceed to create the exam
            axios.post(EXAMS_API,{
    ...formData,
    SectionID: hasSections ? formData.SectionID : null
})
            .then(() => {
              alert("Exam created successfully!");
              setFormData({
                ExamName: "",
                SubjectIDs: [],
                CourseID: "",
                ClassID: "",
                SectionID: "",
                AcademicYearID: "",
                MinMarks: "",
                TotalMarks: "",
                CreatedBy: "admin",
                CreatedDate: new Date().toISOString().split("T")[0],
                UpdatedBy: null,
                UpdatedDate: null,
              });
              setSubjects([]);
              setClasses([]);
              setAcademicYears([]);
            })
            .catch((error) => {
              console.error(error);
              alert("Error creating exam.");
            });
        }
      })
      .catch((error) => { 
        alert("Exam name alredy Exist!.");
      });
  }; */

const handleSubmit = async (e) => {

    e.preventDefault();

    if (!validateForm()) return;

    try {

        const payload = {

            ExamName: formData.ExamName,

            CourseID: formData.CourseID,

            AcademicYearID: formData.AcademicYearID,
             /* ExamDate:
                    formData.ExamDate,

                StartTime:
                    formData.StartTime,

                EndTime:
                    formData.EndTime, */

            //ClassIDs: formData.ClassIDs,
            Classes: formData.Classes,

            /* SectionIDs:

                hasSections

                    ? formData.SectionIDs

                    : [], */

            SubjectIDs: formData.SubjectIDs,
            SubjectSchedules: formData.SubjectSchedules,


            MinMarks: formData.MinMarks,

            TotalMarks: formData.TotalMarks,

            CreatedBy: formData.CreatedBy,

            CreatedDate: formData.CreatedDate

        };

        //------------------------------------------------
        // Duplicate Check
        //------------------------------------------------

        const duplicate = await axios.post(

            CHECK_EXAM_NAME_API,

            payload

        );

        if (duplicate.data.exists) {

            alert(

                duplicate.data.message ||

                "Exam already exists."

            );

            return;

        }

        //-----------------------------------------------
        // Save Exam
        //-----------------------------------------------

        await axios.post(

            EXAMS_API,

            payload

        );

        alert("Exam Created Successfully.");

        //-----------------------------------------------
        // Reset Form
        //-----------------------------------------------

        setFormData({

            ExamName: "",

            SubjectIDs: [],

            CourseID: "",

            AcademicYearID: "",
             ExamName: "",

                 SubjectSchedules: {},
           /*  ClassIDs: [],

            SectionIDs: [], */


            Classes: [
    {
        ClassID: "",
        SectionIDs: []
    }
],


            MinMarks: "",

            TotalMarks: "",

            CreatedBy: "admin",

            CreatedDate:

                new Date()

                .toISOString()

                .split("T")[0],

            UpdatedBy: null,

            UpdatedDate: null

        });

        setClasses([]);

        //setSections([]);

        setSubjects([]);

        setAcademicYears([]);

        //setHasSections(false);

    }

    catch (error) {

        console.log(error);

        if (

            error.response &&

            error.response.data &&

            error.response.data.message

        ) {

            alert(error.response.data.message);

        }

        else {

            alert("Unable to create Exam.");

        }

    }

};

const addClass=()=>{

setFormData(prev=>({

...prev,

Classes:[
...prev.Classes,

{

ClassID:"",
SectionIDs:[]

}

]

}));

};

const removeClass=(index)=>{

setFormData(prev=>({

...prev,

Classes:prev.Classes.filter((_,i)=>i!==index)

}));

};

const handleClassChange=(index,classId)=>{

const updated=[...formData.Classes];

updated[index].ClassID=classId;

updated[index].SectionIDs=[];

/* setFormData({

...formData,

Classes:updated

}); */
setFormData(prev => ({

    ...prev,

    Classes: updated

}));
axios

.get(`${BASE_URL}/api/sections/${classId}`)

.then(res=>{

setSectionMap(prev=>({

...prev,

[classId]:res.data

}));

});

};

const handleSectionChange=(index,newSections)=>{

const updated=[...formData.Classes];

updated[index].SectionIDs=

newSections.map(x=>x.SectionID);

/* setFormData({

...formData,

Classes:updated

}); */
setFormData(prev => ({

    ...prev,

    Classes: updated

}));
};


  return (
    <div className="container mt-5">
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-body p-5">
          <h2 className="card-title mb-4 text-center">Create New Exam</h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Exam Name</label>
                <input
                  type="text"
                  name="ExamName"
                  value={formData.ExamName}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Course</label>
                <select
                  name="CourseID"
                  value={formData.CourseID}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((c) => (
                    <option key={c.CourseID} value={c.CourseID}>
                      {c.CourseName}
                    </option>
                  ))}
                </select>
              </div>
 {/* Academic Year */}
              <div className="col-md-6">
                <label className="form-label">Academic Year</label>
                <select
                  name="AcademicYearID"
                  value={formData.AcademicYearID}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                >
                  <option value="">Select Academic Year</option>
                  {academicYears.map((y) => (
                    <option key={y.id} value={y.id}>
                      {y.name}
                    </option>
                  ))}
                </select>
              </div>



              {/* <div className="col-md-6">

<label className="form-label fw-bold">

Select Classes

</label>

<Autocomplete

multiple

disableCloseOnSelect

options={classes}

getOptionLabel={(option)=>option.name}

value={

classes.filter(cls=>

formData.ClassIDs.includes(cls.ClassID)

)

}

onChange={(event,newValue)=>{

setFormData(prev=>({

...prev,

ClassIDs:newValue.map(item=>item.ClassID),

SectionIDs:[]

}));

}}

renderOption={(props,option,{selected})=>(

<li {...props}>

<Checkbox

icon={icon}

checkedIcon={checkedIcon}

checked={selected}

sx={{mr:1}}

/>

{option.name}

</li>

)}

renderInput={(params)=>

<TextField

{...params}

placeholder="Choose Classes"

/>

}

/>

</div> */}


{

formData.Classes.map((item,index)=>(

<div
key={index}
className="border rounded p-3 mb-3"
>

<div className="row">

<div className="col-md-5">

<label>

Class

</label>

<Autocomplete

options={classes}

getOptionLabel={(option)=>option.name}

value={

classes.find(

c=>c.ClassID===item.ClassID

)||null

}

onChange={(e,value)=>{

handleClassChange(

index,

value?.ClassID || ""

);

}}

renderInput={(params)=>

<TextField

{...params}

placeholder="Select Class"

/>

}

/>

</div>

<div className="col-md-5">

<label>

Sections

</label>

<Autocomplete

multiple

disableCloseOnSelect

options={

sectionMap[item.ClassID] || []

}

getOptionLabel={(option)=>

option.SectionName

}

value={

(sectionMap[item.ClassID]||[])

.filter(sec=>

item.SectionIDs.includes(

sec.SectionID

)

)

}

onChange={(e,newValue)=>{

handleSectionChange(

index,

newValue

);

}}

renderOption={(props,option,{selected})=>(

<li {...props}>

<Checkbox

checked={selected}

/>

{option.SectionName}

</li>

)}

renderInput={(params)=>

<TextField

{...params}

placeholder="Select Sections"

/>

}

/>

</div>

<div className="col-md-2 d-flex align-items-end">

{

formData.Classes.length>1 &&

<button

type="button"

className="btn btn-danger"

onClick={()=>removeClass(index)}

>

Remove

</button>

}

</div>

</div>

</div>

))

}

<button

type="button"

className="btn btn-success"

onClick={addClass}

>

+ Add Class

</button>
              
{/* {

hasSections && (

<div className="col-md-6">

<label className="form-label fw-bold">

Select Sections

</label>

<Autocomplete

multiple

disableCloseOnSelect

options={sections}

getOptionLabel={(option)=>option.SectionName}

value={

sections.filter(sec=>

formData.SectionIDs.includes(sec.SectionID)

)

}

onChange={(event,newValue)=>{

setFormData(prev=>({

...prev,

SectionIDs:newValue.map(item=>item.SectionID)

}));

}}

renderOption={(props,option,{selected})=>(

<li {...props}>

<Checkbox

icon={icon}

checkedIcon={checkedIcon}

checked={selected}

sx={{mr:1}}

/>

{option.SectionName}

</li>

)}

renderInput={(params)=>

<TextField

{...params}

placeholder="Choose Sections"

/>

}

/>

</div>

)
} */}

              {/* <div className="col-md-6">
                <label className="form-label">Subjects</label>
                <div className="border rounded-3 p-3" style={{ maxHeight: 200, overflowY: "auto" }}>
                  {subjects.length === 0 ? (
                    <p className="text-muted">No subjects available.</p>
                  ) : (
                    subjects.map((s) => (
                      <div key={s.SubjectID} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`subject-${s.SubjectID}`}
                          checked={formData.SubjectIDs.includes(s.SubjectID)}
                          onChange={() => handleSubjectCheckbox(s.SubjectID)}
                        />
                        <label className="form-check-label" htmlFor={`subject-${s.SubjectID}`}>
                          {s.SubjectName}
                        </label>
                      </div>
                    ))
                  )}
                </div>
              </div> */}



              <div className="col-md-12">

<label className="form-label">

Subjects

</label>

<div

className="border rounded-3 p-3"

style={{

maxHeight:250,

overflowY:"auto"

}}

>

{

subjects.length===0 ?

(

<div className="text-muted">

No Subjects Found

</div>

)

:

subjects.map(subject=>(

<div

key={subject.SubjectID}

className="form-check"

>

<input

type="checkbox"

className="form-check-input"

id={`sub_${subject.SubjectID}`}

checked={

formData.SubjectIDs.includes(

subject.SubjectID

)

}

onChange={()=>handleSubjectCheckbox(subject.SubjectID)}

/>

<label

className="form-check-label"

htmlFor={`sub_${subject.SubjectID}`}

>

{subject.SubjectName}

</label>

</div>

))

}

</div>

</div>

{/*ExamDate,StartTime */}

{formData.SubjectIDs.length > 0 && (

    <div className="col-md-12 mt-4">

        <div className="card border-0 shadow-sm">

            <div className="card-header bg-primary text-white">
                <h5 className="mb-0">
                    Exam Schedule
                </h5>

                <small>
                    Select individual Exam Date and Time
                    for each subject
                </small>
            </div>

            <div className="card-body">

                <div className="table-responsive">

                    <table className="table table-bordered align-middle">

                        <thead className="table-light">

                            <tr>

                                <th>
                                    Subject
                                </th>

                                <th style={{ minWidth: "180px" }}>
                                    Exam Date
                                </th>

                                <th style={{ minWidth: "150px" }}>
                                    Start Time
                                </th>

                                <th style={{ minWidth: "150px" }}>
                                    End Time
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {formData.SubjectIDs.map(
                                subjectId => {

                                    const subject =
                                        subjects.find(
                                            s =>
                                                Number(s.SubjectID) ===
                                                Number(subjectId)
                                        );

                                    const schedule =
                                        formData.SubjectSchedules[
                                            subjectId
                                        ] || {};

                                    return (

                                        <tr key={subjectId}>

                                            <td>
                                                <strong>
                                                    {
                                                        subject?.SubjectName ||
                                                        "Unknown Subject"
                                                    }
                                                </strong>
                                            </td>

                                            <td>

                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    min={
                                                        today
                                                    }
                                                    value={
                                                        schedule.ExamDate ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        handleSubjectScheduleChange(
                                                            subjectId,
                                                            "ExamDate",
                                                            e.target.value
                                                        )
                                                    }
                                                    /* required */
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={
                                                        schedule.StartTime ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        handleSubjectScheduleChange(
                                                            subjectId,
                                                            "StartTime",
                                                            e.target.value
                                                        )
                                                    }
                                                   /*  required */
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={
                                                        schedule.EndTime ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        handleSubjectScheduleChange(
                                                            subjectId,
                                                            "EndTime",
                                                            e.target.value
                                                        )
                                                    }
                                                    /* required */
                                                />

                                            </td>

                                        </tr>

                                    );

                                }
                            )}

                        </tbody>

                    </table>

                </div>

                <div className="alert alert-info mt-3 mb-0">

                    <strong>Note:</strong>{" "}
                    Exam Date can only be today or a future
                    date. Each subject can have a different
                    date and time.

                </div>

            </div>

        </div>

    </div>

)}



              <div className="col-md-6">
                <label className="form-label">Min Marks</label>
                <input
                  type="number"
                  name="MinMarks"
                  value={formData.MinMarks}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Total Marks</label>
                <input
                  type="number"
                  name="TotalMarks"
                  value={formData.TotalMarks}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>
            </div>
            <div className="text-center mt-4">
              <button type="submit" className="btn btn-primary px-4 py-2 rounded-pill shadow-sm">
                Create Exam
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ExamPage;
